import React, { useEffect, useState, useContext } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { buildEventOpenGraph } from '@blocktickets/shared-utils'
import LoadingContext from '../../context/Loading/Loading'

import { getEventByShortCode } from '../../utilities/api'

import { NewGAPurchaseWrapper, PageLoadingContainer } from '../../components'
import NotFoundPage from '../NotFoundPage/NotFoundPage'
import OpenGraph from '../../components/OpenGraph/OpenGraph'

import { initializeTracking, trackViewItem } from '../../utilities/tracking'
import { rememberTrackingCode } from '../../utilities/trackingLink'
import { cacheEventBranding } from '../../utilities/orgBrandingCache'
import useWaitingRoomHeartbeat from '../../hooks/useWaitingRoomHeartbeat'
import {
  hasValidWaitingRoomToken,
  isWaitingRoomRequired,
  redirectToWaitingRoom,
} from '../../utilities/waitingRoom'

export default function NewGAPurchasePage() {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()

  let { shortcode, slug } = useParams()

  let code = searchParams.get('code') ? searchParams.get('code') : 0

  const [event, setEvent] = useState()
  const [hasError, setHasError] = useState(false)

  useWaitingRoomHeartbeat(
    event?.uuid,
    isWaitingRoomRequired(event) && hasValidWaitingRoomToken(event?.uuid)
  )

  useEffect(() => {
    showLoading()
    getEventByShortCode(shortcode, slug, code)
      .then((res) => {
        const organization =
          res.data?.organization || res.data?.event?.organization

        initializeTracking(organization)
        cacheEventBranding(res.data?.event, organization)

        if (res.data?.status === 404) {
          hideLoading()
          setHasError(true)
          return
        }
        setHasError(false)
        const loadedEvent = res.data?.event
        rememberTrackingCode(loadedEvent?.uuid, code)
        if (
          isWaitingRoomRequired(loadedEvent) &&
          !hasValidWaitingRoomToken(loadedEvent.uuid)
        ) {
          redirectToWaitingRoom(
            navigate,
            slug,
            shortcode,
            loadedEvent.uuid,
            'ga'
          )
          return
        }
        setEvent(loadedEvent)
        trackViewItem({
          organization,
          event: res.data?.event,
        })
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        setTimeout(() => hideLoading(), 700)
      })
    console.log('Loaded')
  }, [shortcode]) // load event whenever event code changes

  const openGraph = buildEventOpenGraph(event)

  return (
    <div className="full-height-wrapper">
      <OpenGraph {...openGraph} />
      {event && (
        <Helmet>
          <meta charSet="utf-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, maximum-scale=1"
          />
          <meta name="theme-color" content="#000000" />
          <meta name="keywords" content={openGraph.description} />
        </Helmet>
      )}
      {/* Seems we only need event, so probs can just not have all of the above
       */}
      {isLoading ? (
        <PageLoadingContainer organization={event?.organization} />
      ) : (
        <>
          {event && !hasError && <NewGAPurchaseWrapper event={event} />}

          {hasError && <NotFoundPage />}
        </>
      )}
    </div>
  )
}
